(function() {
  if (App.angularApp == null) {
    return;
  }


  /*
   * mf-phone-format
   *
   * takes string, strips non-numeric and formats string into "(999) 999-9999"
   *
   */

  App.angularApp.filter('mfPhoneFormat', function() {
    return function(input) {
      if (!input || input.match(/[a-zA-Z]/)) {
        return input;
      }
      input = input.replace(/\D/g, '');
      return input.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
    };
  });

}).call(this);
